/* =================== MINHA CONTA =================== */
jQuery(document).ready(function ($) {

  // Marca tarefa
  $(".marca-tarefa").on("click", function () {
    /* e.preventDefault(); */
    var id = $(this).data('id');
    var element = $(this);
    var dataString = {
      id: id,
      acao: 'update'
    }
    $.ajax({
      type: "POST",
      url: url_base + 'acoes/app/cliente/marca_tarefa.php',
      data: dataString,
      cache: false,
      success: function (resultado) {
        console.log(resultado);
        if (resultado == 'ok-1') {
          element.find('i').removeClass();
          element.find('i').addClass('fas fa-check-square');
          element.parent().addClass('checked');
        } else if (resultado == 'ok-0') {
          element.find('i').removeClass();
          element.find('i').addClass('far fa-square');
          element.parent().removeClass('checked');
        }
        $('.TotalCheck').html($('.fa-check-square').length);
      },
      error: function (xhr, type, exception) {
        showAlert("Erro", "Não foi possível realizar a operação.", "error");
      }
    });
  });


  // Valor disponivel para gastos
  $("#valor_disponivel").on("change", function () {
    /* e.preventDefault(); */
    var valor_disponivel = $(this).val();
    var dataString = {
      valor_disponivel: valor_disponivel,
      acao: 'update'
    }
    $.ajax({
      type: "POST",
      url: url_base + 'acoes/app/cliente/atualiza_orcamento_geral.php',
      data: dataString,
      cache: false,
      success: function (resultado) {
        console.log(resultado);
        location.reload();
      },
      error: function (xhr, type, exception) {
        showAlert("Erro", "Não foi possível realizar a operação.", "error");
      }
    });
  });

  // Envia convite
  $(".envia-convite").on("click", function () {
    /* e.preventDefault(); */
    var id = $(this).data("id");
    var tipo = $(this).data("tipo");
    var dataString = {
      id: id,
      tipo: tipo,
      acao: 'convite'
    }
    $.ajax({
      type: "POST",
      url: url_base + 'acoes/app/cliente/envia_convite.php',
      data: dataString,
      cache: false,
      success: function (resultado) {
        console.log(resultado);
        if (resultado == "erro") {
          showAlert("Atenção", "Não foi possivel enviar o convite.", "warning");
        } else {
          showAlert("Sucesso", "Convite enviado! <br> Aguarde alguns segundos.", "success");
        }
        setTimeout(() => {
          location.reload();
        }, 2500);
      },
      error: function (xhr, type, exception) {
        showAlert("Erro", "Não foi possível realizar a operação.", "error");
      }
    });
  });

  // Troca de festa
  $(".btn-troca-festa").on("click", function (e) {
    e.preventDefault();
    var id_festa = $(this).data("id");
    var dataString = {
      id_festa: id_festa,
      acao: 'troca'
    }
    $.ajax({
      type: "POST",
      url: url_base + 'acoes/app/cliente/troca_festa.php',
      data: dataString,
      cache: false,
      success: function (resultado) {
        console.log(resultado);
        if (resultado == "erro") {
          showAlert("Atenção", "Não foi possivel realizar a troca de festa.", "warning");
        } else {
          showAlert("Sucesso", "Troca realizada! <br> Aguarde alguns segundos.", "success");
        }
        setTimeout(() => {
          window.location.href = url_base + 'cliente/inicio';
        }, 2500);
      },
      error: function (xhr, type, exception) {
        showAlert("Erro", "Não foi possível realizar a operação.", "error");
      }
    });
  });

  // Adiciona anuncio ao favoritos do cliente
  $(".btn-addfavorito").on("click", function (e) {
    e.preventDefault();
    var btnAct = $(this);
    var idAnuncio = $(this).data("id");
    var dataString = {
      id_anuncio: idAnuncio,
      acao: 'insert'
    }
    $.ajax({
      type: "POST",
      url: url_base + 'acoes/app/cliente/adicionar_favorito.php',
      data: dataString,
      cache: false,
      success: function (resultado) {
        console.log(resultado);
        if (resultado == "erro") {
          showAlert("Atenção", "Não foi possivel adicionar aos favoritos.", "warning");
        } else {
          btnAct.find('.far').removeClass('h');
          btnAct.find('.far').addClass('s');
          btnAct.find('.fas').removeClass('s');
          btnAct.find('.fas').addClass('h');
          showAlert("Sucesso", "Adicionado aos seus favoritos.", "success");
        }
        setTimeout(() => {
          //location.reload();
        }, 2500);
      },
      error: function (xhr, type, exception) {
        showAlert("Erro", "Não foi possível realizar a operação.", "error");
      }
    });
  });

  // Remove anuncio ao favoritos do cliente
  $(".btn-delfavorito").on("click", function (e) {
    e.preventDefault();
    var btnAct = $(this);
    var idFavorito = $(this).data("id");
    var dataString = {
      id_favorito: idFavorito,
      acao: 'remover'
    }
    $.ajax({
      type: "POST",
      url: url_base + 'acoes/app/cliente/remover_favorito.php',
      data: dataString,
      cache: false,
      success: function (resultado) {
        console.log(resultado);
        if (resultado == "erro") {
          showAlert("Atenção", "Não foi possivel remover dos favoritos.", "warning");
        } else {
          btnAct.find('.fas').removeClass('s');
          btnAct.find('.fas').addClass('h');
          btnAct.find('.far').removeClass('h');
          btnAct.find('.far').addClass('s');
          showAlert("Sucesso", "Removido do seus favoritos.", "success");
        }
        setTimeout(() => {
          //location.reload();
        }, 2500);
      },
      error: function (xhr, type, exception) {
        showAlert("Erro", "Não foi possível realizar a operação.", "error");
      }
    });
  });

  // Exibe a confirmação ao clicar no botão de mudanca de status
  $(".btn-status").on("click", function (e) {
    e.preventDefault();
    var idStatus = $(this).data("id");
    var valueStatus = $(this).data("value");
    $("#id_status").val(idStatus);
    $("#value_status").val(valueStatus);
    if (valueStatus == 1) {
      $(".frase-status").html('aprovar');
    } else {
      $(".frase-status").html('reprovar');
    }
    openModal("modal-status");
  });


  // Exibe a confirmação ao clicar no botão de mudanca de status
  $(".btn-status2").on("click", function (e) {
    e.preventDefault();
    var idStatus = $(this).data("id");
    var valueStatus = $(this).data("value");
    $("#id_status").val(idStatus);
    $("#value_status").val(valueStatus);
    if (valueStatus == 1) {
      $(".frase-status").html('responder');
    } else {
      $(".frase-status").html('não respondido');
    }
    openModal("modal-status");
  });

  // Exibe a confirmação ao clicar no botão de remover
  $(".btn-confirm").on("click", function (e) {
    e.preventDefault();
    var idRemove = $(this).data("id");
    $("#id_remove").val(idRemove);
    openModal("modal-confirm");
  });

  // Exibe a confirmação ao clicar no botão de cancelar plano
  $(".btn-cancela").on("click", function (e) {
    e.preventDefault();
    var idCancela = $(this).data("id");
    $("#id_cancela").val(idCancela);
    openModal("modal-cancelar");
  });

  // Sem CNPJ
  function verifyCnpjC(el) {
    if (el.is(':checked')) {
      $('.campo-cnpj').hide();
      $('#cnpj').attr('required', false);
      $('#cnpj').val('');
    } else {
      $('.campo-cnpj').show();
      $('#cnpj').attr('required', true);
    }
  }
  $("#sem_cnpj").on("change", function () {
    verifyCnpjC($("#sem_cnpj"));
  });
  verifyCnpjC($("#sem_cnpj"));

  // Exibe/Oculta os campos da forma de pagamento escolhida
  $('input[name="forma-pagamento"]').on("change", function () {
    $(".forma-pag-content").slideUp();
    $(".forma-pag-content .campo").prop("disabled", true);
    $(".forma-pag-content .campo").prop("required", false);

    $('.forma-pag-content[data-forma="' + $(this).val() + '"]').slideDown();
    $('.forma-pag-content[data-forma="' + $(this).val() + '"] .campo').prop(
      "disabled",
      false
    );
    $('.forma-pag-content[data-forma="' + $(this).val() + '"] .campo').prop(
      "required",
      true
    );
  });

  // Verifica email
  function verificaEMAIL(value) {
    var pathEmail = url_base + 'acoes/app/cadastro/verifica_email.php';
    var dados = {
      email: $('#email').val(),
      tabela: value
    }
    console.log(dados);
    $.ajax({
      type: "POST",
      url: pathEmail,
      data: dados,
      success: function (resposta) {
        if (resposta == "erro") {
          $('#email').val('');
          showAlert("Atenção", "E-mail já esta sendo utilizado.", "warning");
        }
      },
      error: function (xhr, type, exception) {
        volta_submit();
        showAlert("Erro", "Não foi possível enviar a mensagem.", "error");
        console.log("ajax error response type " + type);
      }
    });
  }
  $('input[type=radio][name="conta"]').change(function () {
    verificaEMAIL($(this).val());
  });
  $('#email').on('change', function () {
    if ($("input[type=radio][name='conta']").is(':checked')) {
      verificaEMAIL($('input[type=radio][name="conta"]:checked').val());
    }
  });

});
